<template>
  <div class="pr-10">
    <div class="hr-line col-sm-12 col-xs-12 col-md-12 p-0">
      <hr class="mb-26"/>
    </div>
    <div class="col-xs-12 p-0">
      <p class="billing-info">{{$t('billingInformation')}}</p>
    </div>
    <div class="col-sm-12 col-xs-12 box-wrapper">
      <div class="col-xs-12 col-sm-6 col-sm-push-6">
        <div class="unrestrict-button">
          <button
            class="btn emergo-red-button"
            @click="openConfirmationPopup()"
            v-if='member.is_restricted'
          >
            {{ $t('unBlock')}}
          </button>
        </div>
        <div class="col-xs-12 col-sm-10 img-blk p-0">
          <div
            class="profile-pic-edit profile-pic-title-edit"
            v-if="!member.profile_pic"
          >
            {{ getInitials(member.first_name, member.last_name) }}
          </div>
          <img
            class="profile-pic-edit"
            v-if="member.profile_pic"
            :src="member.profile_pic"
          />
          <div>
            <p class="warn-restriction" v-if="member.is_restricted">
              {{ $t('teamMemberRestriction')}}
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-sm-pull-6 col-xs-12">
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('firstName')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Name"
              :value="member.first_name"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('lastName')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Name"
              :value="member.last_name"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">Email</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="Email"
              :value="member.email"
              class="form-control"
              disabled
            />
          </div>
        </div>
        <div class="row mr-bt-28" v-if="multi_factor_key">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">IP Address</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <input
              type="text"
              placeholder="IP Address (xxx.xxx.xxx.xxx)"
              class="form-control"
              v-model="ipAddress"
              @blur="ipAddressVal"
              :disabled="member.is_restricted"
            />
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">{{ $t('role')}}</div>
          <div class="col-sm-12 col-xs-12 col-md-10">
            <div class="custom-dropdown mt-4">
              <multiselect
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                :searchable="false"
                openDirection="below"
                :options="roles.map(role => role.id)"
                :custom-label="option => roles.find(x => x.id === option).name"
                v-model="roleId"
                @input="getRoleBasedTemplate(roleId,'role')"
                :placeholder="$t('selectRole')"
              >
            </multiselect>
            </div>
          </div>
        </div>
        <div class="row mr-bt-28" v-if="roleId == 6">
          <div class="field-name col-sm-12 col-xs-12 col-md-12">Distributor</div>
          <div class="col-sm-12 col-xs-12 col-md-10 custom-dropdown">
            <multiselect
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="false"
              class="multiselect-single-dropdown"
              :searchable="false"
              :options="distributors.map(distributor => distributor.id)"
              :custom-label="option => distributors.find(x => x.id === option).distributor_name"
              v-model="distributorId"
              placeholder="Select Role"
            >
          </multiselect>
          </div>
        </div>
        <div class="row mr-bt-28">
          <div class="col-sm-12 col-xs-12 col-md-10 pl-13">
            <div v-if="displayIpErrorMsg" class="error-msg-holder custom-error">
              <span class="error-message-response">Invalid IP Address.</span>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mr-bt-5p serviceAccess" v-if="userServiceList && userServiceList.length && complianceServices.length && this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
        <h4 class="serviceAccessText">{{ $t('serviceAccess')}}</h4>
        <hr class="horizontalLineOne"/>
        <div class="complianceTrackerOuter">
          <ul>
            <li class="main-content" v-for="(service, index) in userServiceList" :key="index">
              <div class="row">
                <div class="col-xs-12 complianceTracker">
                  <div class="col-xs-8 col-sm-8 col-md-8 pl-10 greenCheckMark">
                    <img src="/static/images/icons/green_circle_check.svg" alt="" class="img">
                    <h4 class="complianceTrackerText">{{service.name}}</h4>
                  </div>
                  <div class="col-xs-4 complianceTrackerCarret">
                    <span>
                      <button data-toggle="collapse" data-target="#collapseComplianceTracker" data-parent="#accordion">
                        <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                        <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="collapse" id="collapseComplianceTracker">
                <ul>
                  <li class="main-content" v-for="(service_module, ind) in service.modules" :key="ind">
                    <div class="row pt-10">
                      <div class="complianceTrackerRecords pb-8">
                        <!-- <div class="form-check d-flex col-xs-8 col-sm-8 mt-35">
                          <input class="form-check-input" type="checkbox" v-model="complianceServices[index][service.key].parent" @change="toggleRecords('parent',service.key,index)" id="records">
                          <label class="form-check-label" for="records">
                            {{service_module.name}}
                          </label>
                        </div> -->
                        <div class="form-check d-flex col-xs-8 col-sm-8 mt-35">
                          <label class="custom-checkbox">
                            <input type="checkbox" id="records" v-model="complianceServices[index][service.key].parent" @change="toggleRecords('parent',service.key,index)" />
                            <span class="select-check"></span>
                          </label>
                          <span class="pl-24 module-name">{{service_module.name}}</span>
                        </div>
                        <div class="carretTwo col-xs-8 col-sm-4">
                          <span>
                            <button data-toggle="collapse" class="pt-40" data-target="#collapseComplianceTrackerRecords" data-parent="#accordion">
                              <img src="/static/images/icons/account_settings_arrow.svg" class="downCarret" />
                              <img src="/static/images/icons/account_settings_arrow.svg" class="upCarret" />
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <ul class="collapse complianceTrackerRecordItems" id="collapseComplianceTrackerRecords">
                      <li v-for="(operation, i) in service_module.operations" :key="i">
                        <!-- <div class="form-check d-flex" v-if="complianceServices[index][service.key].child[i]">
                          <input class="form-check-input" type="checkbox" v-model="complianceServices[index][service.key].child[i].access" id="records" @change="toggleRecords('child',service.key,index)">
                          <label class="form-check-label" for="recordItems">
                            {{operation.name}}
                          </label>
                        </div> -->
                        <div class="form-check d-flex col-xs-8 col-sm-8 mt-35" v-if="complianceServices[index][service.key].child[i]">
                          <label class="custom-checkbox">
                            <input type="checkbox" id="records" v-model="complianceServices[index][service.key].child[i].access" @change="toggleRecords('child',service.key,index)" />
                            <span class="select-check"></span>
                          </label>
                          <span class="pl-24 module-name fw-400">{{operation.name}}</span>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
            </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer_buttons">
      <div class="col-md-6 col-xs-6 col-sm-6  footer_left_button">
        <button type="button" class="btn btn-block blue_outline_back_button" @click="cancelEditTeam">{{ $t('back')}}</button>
      </div>
      <div class="col-xs-6 footer_right_buttons_section">
            <button type="button" class="btn btn-block blue_outline_cancel_button" @click="cancelEditTeam">{{ $t('cancel')}}</button>
            <button
              type="button"
              class="blue_save_changes_button"
              @click="updateTeamMember()"
              :disabled="disableButtonForAddTeam || loaderStatus"
            >{{ $t('save')}}</button>
      </div>
    </div>
    <!-- <div
      class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding"
      v-if="!member.is_restricted"
    >
      <div
        class="
          col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5
          xs-pd-lt-0
        "
      >
        <button
          type="button"
          class="btn btn-block emergo-white-button"
          @click="cancelEditTeam"
        >
          Cancel
        </button>
      </div>
      <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
        <button
          type="button"
          class="btn btn-block emergo-green-button"
          @click="updateTeamMember()"
          :disabled="disableButtonForAddTeam || loaderStatus"
        >
          Save Changes
        </button>
      </div>
    </div> -->
    <loader :loadingStatus="loaderStatus"></loader>
    <member-permissions
      :member="member.first_name + ' ' + member.last_name"
      :serviceId="serviceId"
      :userServiceList="userServiceList"
      :rolesServicesList="servicesList"
      @updateUserPermission="updateUserPermission"
    >
    </member-permissions>
    <div id="confirmaton_popup" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor">
            <button
              type="button"
              class="close"
              data-toggle="modal"
              data-target="#confirmaton_popup"
            >
              &times;
            </button>
            <h4 class="modal-title">
              Are you sure you want to unblock the member?
            </h4>
            <p class="user-name">{{ member.email }}</p>
            <p class="unblock-modal-content">
              By unblocking this user, you will utilize one (1) available Team
              Member subscription. The user will regain all previous access
              levels.
            </p>
          </div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-sm-6 col-xs-12 txt-alg-rt">
              <button
                type="button"
                class="btn emergo-white-button btn-width-confirm"
                data-toggle="modal"
                data-target="#confirmaton_popup"
              >
                Cancel
              </button>
            </div>
            <div class="col-sm-6 col-xs-12 text-left">
              <button
                type="button"
                class="btn emergo-green-button btn-width-confirm"
                @click="updateTeamMemberRestriction()"
              >
                Yes, unblock user
              </button>
            </div>
          </div>
          <loader :loadingStatus="confirmLoaderStatus"></loader>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import _ from 'lodash';
import cloneDeep from 'clone-deep';
import Loader from '../../UIComponents/Loader.vue';
import EventBus from '../../../utils/event-bus';
import {
  getRoleBasedPermissions,
  getUserPermissions,
} from '../../../apis/rbac';

import {
  updateTeamMember,
  updateTeamMemberRestriction,
  // getAccountOwnersCount,
} from '../../../apis/team';
import {
  isDefaultDashboard,
  setDefaultPreference,
} from '../../../apis/dashboardCustomization';
import servicesMixin from '../../UIComponents/mixins/servicesMixin';
import permissionsList from '../../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [servicesMixin, permissionsList],
  props: [
    'member',
    'roles',
    'distributors',
    'getTeamMembers',
    'cancelAddTeam',
    'multi_factor_key',
    'account_type_id',
  ],
  components: {
    Loader,
  },
  data() {
    return {
      displayIpErrorMsg: false,
      loaderStatus: false,
      permissions: [],
      servicesList: [],
      serviceId: '',
      userServiceList: [],
      usersPermission: {},
      roleId: null,
      distributorId: null,
      ipAddress: null,
      confirmLoaderStatus: false,
    };
  },
  async created() {
    await this.validateFeatures();
    await this.getPermissionsList();
    this.roleId = this.member.role_id;
    this.distributorId = this.member.assigned_distributor_id;
    this.ipAddress = this.member.ip_address;
    EventBus.$on('resetTeams', () => {
      this.cancelEditTeam();
    });
  },
  computed: {
    disableButtonForAddTeam() {
      if (this.roleId === 6 && !this.distributorId) return true;
      if (this.member.role_id !== this.roleId) return false;
      if (this.member.ip_address !== this.ipAddress) {
        const ipAddressFormat =          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
        if (this.ipAddress && this.ipAddress.match(ipAddressFormat)) {
          return false;
        }
      }
      if (this.member.role_id === this.roleId) {
        if (this.distributorId !== this.member.assigned_distributor_id) return false;
        let diff = true;
        for (let i = 0; i < this.userServiceList.length; i += 1) {
          const obj2 = this.usersPermission.services.find(
            (service) => service.id === this.userServiceList[i].id,
          );
          if (!_.isEqual(this.userServiceList[i], obj2)) {
            diff = false;
            break;
          }
        }
        return diff;
      }
      return true;
    },
  },
  watch: {
    roleId() {
      if (this.roleId === 6 && this.roleId === this.member.role_id) this.distributorId = this.member.assigned_distributor_id;
      else this.distributorId = null;
    },
  },
  beforeDestroy() {
    EventBus.$off('resetTeams');
  },
  methods: {
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    removeNull(array) {
      return array.filter((item) => item);
    },
    openConfirmationPopup() {
      $('#confirmaton_popup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async updateTeamMemberRestriction() {
      // const check = this.account_type_id !== 1
      //   && this.account_type_id !== 5
      //   && (this.roleId === 1 || this.roleId === 9)
      //   ? await this.checkAccountOwnersCount()
      //   : true;
      const check = true;
      if (check) {
        const data = {
          action: 'unrestrict',
          role_id: this.member.role_id,
          user_id: this.member.user_id,
        };
        this.confirmLoaderStatus = true;
        const response = await updateTeamMemberRestriction(data);
        this.confirmLoaderStatus = false;
        if (response && response.status) {
          this.$emit('getTeamMembers');
          this.cancelEditTeam();
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: this.$i18n.locale === 'Portuguese' ? 'Restrição de membros da equipe atualizada com sucesso!' : 'Team member restriction updated successfully!',
            group: 'custom-notification',
          });
        } else {
          this.clearNotifcations();
          const validationMessage = this.$i18n.locale === 'Portuguese' ? 'A atualização da restrição do membro da equipe falhou!' : 'Team member restriction update failed!';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text:
              response && !response.status
                ? response.message
                : validationMessage,
            group: 'custom-notification',
          });
        }
      }
    },
    ipAddressVal() {
      const ipAddressFormat =        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/; //eslint-disable-line
      this.displayIpErrorMsg = false;
      if (this.ipAddress && !this.ipAddress.match(ipAddressFormat)) {
        this.displayIpErrorMsg = true;
      }
    },
    revertOldPermissions(id, access) {
      if (!access) {
        let service;
        if (this.roleId === this.member.role_id) {
          service = this.usersPermission.services.find((s) => s.id === id);
        } else {
          service = this.servicesList.find((s) => s.id === id);
        }
        this.userServiceList.forEach((s, index) => {
          if (s.id === id) {
            this.userServiceList[index].modules = service.modules;
          }
        });
      }
    },
    disablePermissionCheck(serviceid) {
      return this.servicesList.find((service) => service.id === serviceid)
        .access;
    },
    async updateTeamMember() {
      // const check = this.account_type_id !== 1
      //   && this.account_type_id !== 5
      //   && this.roleId !== this.member.role_id
      //   && (this.roleId === 1 || this.roleId === 9)
      //   ? await this.checkAccountOwnersCount()
      //   : true;
      const check = true;
      this.getServicesPermissions();
      if (!this.disableButtonForAddTeam && check) {
        this.loaderStatus = true;
        const data = {
          assigned_role_id: this.roleId,
          user_role_id: this.member.id,
          rbac_permission_inst: this.userServiceList,
          ip_address: this.ipAddress,
        };
        if (this.roleId === 6) data.assigned_distributor_id = this.distributorId;
        const response = await updateTeamMember(data);
        this.loaderStatus = false;
        if (response && response.status) {
          // reset upser preferences to default
          this.loaderStatus = true;
          const isDefault = await isDefaultDashboard(
            this.member.account_id,
            this.member.user_id,
          );
          const dashboardData = {
            account_id: this.member.account_id,
            dashboard_notification_type_id: 1,
            user_id: this.member.user_id,
          };
          if (!isDefault) {
            await setDefaultPreference(dashboardData);
          }
          this.loaderStatus = false;
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: this.$i18n.locale === 'Portuguese' ? 'Membro da equipe atualizado com sucesso!' : 'Team member updated successfully!',
            group: 'custom-notification',
          });
          this.$emit('getTeamMembers');
          this.cancelEditTeam();
        } else {
          this.clearNotifcations();
          const updateText = this.$i18n.locale === 'Portuguese' ? 'Não foi possível atualizar o membro da equipe!' : 'Unable to update Team member!';
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: response.message
              ? response.message
              : updateText,
            group: 'custom-notification',
          });
        }
      }
    },
    // async checkAccountOwnersCount() {
    //   this.loaderStatus = true;
    //   this.confirmLoaderStatus = true;
    //   const response = await getAccountOwnersCount(this.account_type_id);
    //   this.loaderStatus = false;
    //   this.confirmLoaderStatus = false;
    //   if (response && response.status_code === 200) {
    //     if (response.account_owner_count < 5) {
    //       return true;
    //     }
    //     this.clearNotifcations();
    //     this.$notify({
    //       type: 'error',
    //       title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
    //       text: this.$i18n.locale === 'Portuguese' ? 'Máximo de 5 proprietários de conta podem ser adicionados!' : 'Maximum 5 account owners can be added!',
    //       group: 'custom-notification',
    //     });
    //     return false;
    //   }
    //   // this.clearNotifcations();
    //   // this.$notify({
    //   //   type: 'error',
    //   //  title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
    //   //   text: 'Unable to fetch Account Owners Count!',
    //   //   group: 'custom-notification',
    //   // });
    //   return true;
    // },
    updateUserPermission(permissions, serviceId) {
      this.userServiceList.forEach((service, index) => {
        if (service.id === serviceId) {
          this.$set(this.userServiceList, index, permissions);
        }
      });
    },
    cancelEditTeam() {
      this.roleId = null;
      this.distributorId = null;
      this.ipAddress = '';
      this.$emit('cancelAddTeam');
    },
    async getPermissionsList() {
      await this.getRoleBasedTemplate(this.member.role_id);
      this.loaderStatus = true;
      const response = await getUserPermissions(
        this.member.user_id,
        this.member.account_id,
        this.member.role_id,
      );
      this.loaderStatus = false;
      if (response && response.services) {
        // Remove null from response
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({
            ...m,
            operations: this.removeNull(m.operations),
          })),
        }));
        response.services = updatedResponse;
        this.usersPermission = response;
        this.userServiceList = cloneDeep(this.usersPermission.services);
        this.userServiceList.forEach((item) => {
          // eslint-disable-next-line no-unused-vars
          const operationIndex = item.modules[0].operations.findIndex((operation) => operation.name === 'Clear All ');
          if (operationIndex !== -1) {
            item.modules[0].operations[operationIndex].name = 'Reset All';
          }
          const { key } = item;
          this.complianceServices.push({ [key]: { parent: item.modules[0].access, child: item.modules[0].operations } });
        });
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Não é possível obter permissões de usuário!' : 'Unable to get user permissions!',
          group: 'custom-notification',
        });
      }
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${
        lastname ? lastname.charAt(0).toUpperCase() : ''
      }`;
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      $('#permissionsAccess').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async getRoleBasedTemplate(roleId, type) {
      this.loaderStatus = true;
      const response = await getRoleBasedPermissions(roleId);
      this.loaderStatus = false;
      if (response && response.services) {
        // Remove null from response
        const updatedResponse = this.removeNull(response.services).map((x) => ({
          ...x,
          modules: this.removeNull(x.modules).map((m) => ({
            ...m,
            operations: this.removeNull(m.operations),
          })),
        }));
        response.services = updatedResponse;
        // response.services.forEach((service, index) => {
        //   if (
        //     service.service_id
        //     && !this.addedServiceIds.includes(service.service_id)
        //   ) {
        //     response.services[index].access = false;
        //   }
        // });
        this.servicesList = cloneDeep(response.services);
        if (this.roleId === this.member.role_id && type !== 'role') {
          this.userServiceList = cloneDeep(this.usersPermission.services);
        } else this.userServiceList = cloneDeep(this.servicesList);

        if (type === 'role') {
          this.$set(this.userServiceList, 0, response.services[0]);
          this.complianceServices = [];
          this.userServiceList.forEach((item) => {
            const operationIndex = item.modules[0].operations.findIndex((operation) => operation.name === 'Clear All ');
            if (operationIndex !== -1) {
              item.modules[0].operations[operationIndex].name = 'Reset All';
            }
            // eslint-disable-next-line no-unused-vars
            const { key } = item;
            this.complianceServices.push({ [key]: { parent: item.modules[0].access, child: item.modules[0].operations } });
          });
        }
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Não é possível obter permissões padrão para a função!' : 'Unable to get default permissions for the role!',
          group: 'custom-notification',
        });
        this.servicesList = [];
        this.userServiceList = [];
      }
    },
  },
};
</script>
<style scoped>
.fw-400 {
  font-weight: 400 !important;
}
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 3px 40px 6px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 1px 40px 4px 0px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.module-name {
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 600;
}
.billing-info {
  margin-bottom: 32px;
  padding-left: 34px;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}
.pl-13{
  padding-left: 13px !important;
}
.mt-35 {
  margin-top: 35px !important;
}
.pt-40 {
  padding-top: 40px !important;
}
.mr-bt-28{
  margin-bottom: 29px;
}
.pr-10{
  padding-right: 10px;
}
.hr-line{
  padding-right: 5px;
}
.hr-line hr{
  border-top: 1px solid #D3D3D3;
}
.box-wrapper::-webkit-scrollbar {
  width: 6px;
}
.box-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  /* height: 30%; */
  /* height: 118px; */
}
.box-wrapper::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.box-wrapper::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}
.field-name {
  line-height: 19px;
  font-size: 16px;
  color: #3e3e3e;
  margin-bottom: 7px;
}
.field-name:after {
  content: '*';
  font-size: 16px;
  color: #C02032;
  position: relative;
  top: -1px;
  margin-left: 4px;
}
.form-control, .form-control:focus {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 34px;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
  font-size: 16px;
  color: #4d4d4d;
}
.footer_buttons{
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 16px;
  display: flex;
  column-gap: 16px;
  z-index: 100;
  /* padding-left: 270px; */
  right: 0;
}
.footer_left_button{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  background: #ffffff;
  padding-top: 20px;
}
.blue_outline_back_button{
    background-color: #fff;
    border: 1px solid #000001;
    height: 44px;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 9px 16px;
    width: auto;
}
.footer_right_buttons_section{
  display:flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 15px;
  background: #ffffff;
  padding-top: 20px;
  padding-right: 0px;
}
.blue_outline_cancel_button{
    background-color: #E6E6E6;
    border: none;
    height: 44px;
    color: #404040;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 10px 16px !important;
    width: auto;
}
.blue_save_changes_button, .blue_save_changes_button:hover{
  background-color: #01518a;
  border: none;
  height: 44px;
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  margin-top: 0px !important;
  padding: 10px 16px !important;
  width: auto;
}
.footer_right_buttons_section button:disabled{
  cursor: not-allowed;
}
.serviceAccess{
  padding-right: 5px;
}
.serviceAccess .form-check-input{
  width: 18px !important;
  height: 18px !important;
  background: #0B3C61;
  /* position:relative; */
  accent-color:  #0B3C61;
}
.serviceAccess .form-check{
  margin-top: 26px;
}
.serviceAccess .form-check .form-check-label{
  color: #3E3E3E;
  margin-left: 10px;
}
.serviceAccessText{
  margin-left: 10px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.horizontalLineOne{
  margin: 0 10px;
  border-top: 1px solid #D3D3D3;
}
.complianceTrackerOuter{
  margin-right: 28px;
  margin-left: 15px;
  padding-top: 18px;
}
li.main-content span button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
li.main-content span button[aria-expanded="true"] img.downCarret {
  display: none;
}
li.main-content span button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
}
li.main-content span button img.upCarret {
  display: none;
}
.complianceTracker {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* padding:0px; */
}
.complianceTracker .greenCheckMark {
  display:flex;
  align-items: center;
}
.complianceTracker .complianceTrackerCarret {
  display:flex;
  align-items: center;
  justify-content: flex-end;
}
.complianceTracker .complianceTrackerText {
  margin-left: 7px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  margin-top: 0px;
  color: #333;
}
.downCarret,
.upCarret{
  width: 19px;
  height: 19px;
}
ul {
  margin-bottom: 0px;
  padding: 0px;
}
ul li {
  list-style: none;
}
li a {
  text-decoration: none;
}
.complianceTrackerRecords {
  margin-left: 50px;
  display:flex;
  align-items: center;
  justify-content: flex-start;
}
.complianceTrackerRecords .carretTwo {
  display:flex;
  align-items: center;
  justify-content:flex-end;
  padding-right:55px;
}
.complianceTrackerRecordItems li,
.complianceTrackerReportItems li{
  margin-left: 78px;
}
.complianceTracker .complianceTrackerCarret button,
.complianceTrackerRecords .carretTwo button {
  border: none;
  background-color: transparent !important;
  padding: 0px;
}
.complianceTracker .greenCheckMark .img {
  width: 17px;
  height: 17px;
}
.complianceTracker .greenCheckMark {
  display:flex;
  align-items: center;
}
.complianceTracker .greenCheckMark .img {
  width: 17px;
  height: 17px;
}
.confirmpopup-bgcolor {
  border-radius: 12px;
  background-color: #ffffff;
  border: none;
}
.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}
.warn-restriction {
  color: #c02032;
  margin-top: 15px;
}
.modal-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 6px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 14px;
}
.btn-width-confirm {
  width: 230px;
}
.text-left {
  text-align: left;
}
.pb-20 {
  padding-bottom: 20px;
}
.box-wrapper {
  overflow: auto;
  margin-bottom: 10px;
  /* max-height: calc(80vh - 142px); */
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 27px;
  padding-right: 5px;
}
.edit-lnk {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 37px;
  text-align: right;
  padding-right: 15%;
  color: #2f80ed;
  cursor: pointer;
}
.mt-4 {
  margin-top: 4px;
}
.txt-alg-rt {
  text-align: right;
}
.cust_label {
  display: inline-block;
  margin-left: 15px;
  vertical-align: super;
  font-size: 14px;
}
.cust_checkbox {
  display: inline-block;
  cursor: pointer;
}
.checkbox {
  position: relative;
  margin-top: 10px;
  margin-bottom: 5px;
}
input[type="checkbox"] {
  z-index: 1;
  width: 18px !important;
  height: 18px !important;
  left: 0;
  top: 0;
  margin: 0 !important;
}
.checkbox label:before {
  content: "";
  width: 18px !important;
  height: 18px !important;
  border: 1px solid #0b3c61;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}
.checkbox input[type="checkbox"]:checked + label:before {
  background-color: #0b3c61;
  background-image: url(/static/images/icons/checkbox.svg);
  background-size: 12px 16px;
  background-repeat: no-repeat;
  background-position-x: center;
}
.bt-border {
  border-bottom: 1px solid #bdbdbd;
}
.profile-pic-edit {
  width: 170px;
  height: 170px;
  line-height: 170px;
  float: unset;
}
.cursor_pointer {
  cursor: pointer;
}
.profile-pic-title-edit {
  display: inline-block !important;
  background: #CCCCCC;
  color: #3E3E3E;
}
.form-control{
  color:#4D4D4D;
}
.mr-bt-5p {
  margin-bottom: 13%;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: #fff;
}
.img-blk {
  padding-top: 10px;
  text-align: center;
}
.label-selected {
  color: #0b3c61;
  font-weight: 500;
}
.link-disabled {
  opacity: 0.4;
}
@media screen and (min-width: 768px) {
  .hide-sm {
    display: none;
  }
  .unrestrict-button {
    position: absolute;
    top: 10px;
    right: 15px;
  }
}
@media screen and (max-width: 767px) {
  .bt-border {
    padding-bottom: 10px;
  }
  .box-wrapper {
    height: 65vh;
    overflow-y: auto;
  }
  .new_member_img {
    height: 100px;
  }
  .footer {
    padding-bottom: 5%;
  }
  .cust_checkbox {
    margin-left: 5px !important;
  }
  .hide-xs {
    display: none;
  }
  .unrestrict-button {
    float:right;
  }
}
@media screen and (max-width: 600px) {
  .footer_buttons{
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .footer_right_buttons_section,
  .footer_left_button {
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .blue_outline_back_button,
  .blue_outline_cancel_button,
  .blue_save_changes_button{
    width: 100%;
  }
}
@media only screen and (min-width: 1301px) {
  .remove_button_padding {
    padding-left: 230px;
  }
}
@media (max-width: 1300px){
  .footer_buttons{
    padding-left: 15px !important;
  }
}
/* @media (min-width: 768px) and (max-width: 1024px) {
  .box-wrapper {
    height: 45vh;
  }
} */
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px) {
  .box-wrapper {
    height: 52vh;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px) {
  .box-wrapper {
    height: 45vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px),
  (device-width: 667px) and (device-height: 375px) {
  .box-wrapper {
    height: 48vh;
  }
}
.unblock-modal-content {
  font-size: 16px;
  color: #828282;
  text-align: center;
  padding: 40px 40px 0px 40px;
}
.user-name {
  color: #0b3c61;
  text-align: center;
  font-weight: 500;
  font-size: 24px;
}
</style>
